import ListEnum from '../enumerators/list.enum'

export default class InteractiveMapService {
    constructor() {
        //Liste SIT
        if ($(ListEnum.LIST_BLOCK).length > 0) {
            import(
                '../components/list/engine.component' /* webpackChunkName: "scripts/engine.component" */
            ).then(({ default: EngineComponent }) => {
                new EngineComponent()
            })
            /* eslint-disable */
            if (
                typeof IRISCollectionTheme !== 'undefined' &&
                typeof IRISCollectionTheme.data !== 'undefined' &&
                typeof IRISCollectionTheme.data.kml !== '' &&
                IRISCollectionTheme.data.kml !== null
            ) {
                import(
                    '../components/gpx.component' /* webpackChunkName: "scripts/gpx.component" */
                ).then(({ default: GpxComponent }) => {
                    new GpxComponent()
                })
            }
            /* eslint-enable */
        }
    }
}
